import styled from "styled-components";
import { Pre } from "rebass";

const CustomPre = styled(Pre)`
    margin: 1em 0;
`;

export default CustomPre;



// WEBPACK FOOTER //
// ./src/components/CustomPre.js